import { useBrowserLocation } from './browserLocation';

/** Useful public navigation with no guessed account data or readiness promises. */
export default function RouteShell({ notFound = false }: { notFound?: boolean }) {
  const location = useBrowserLocation();
  const key = location.hash.replace(/^#\/?/, '') || location.pathname.replace(/^\//, '') || (location.search.includes('auth=') ? 'signin' : '');
  const intros: Record<string, [string, string]> = {
    app: ['Home', 'Plan your next workout, record meals, and review your training.'],
    home: ['Home', 'Plan your next workout, record meals, and review your training.'],
    today: ['Today', 'Use your workout plan to guide your session and record your training.'],
    food: ['Food', 'Keep your meals and nutrition goals together. Explore free tools for planning your nutrition.'],
    macros: ['Food', 'Keep your meals and nutrition goals together. Explore free tools for planning your nutrition.'],
    progress: ['Progress', 'Review training history, recovery signals, and personal trends.'],
    signin: ['Your account', 'Keep your training and nutrition together in your account.'],
    pricing: ['Plans', 'Explore training tools and choose a plan that fits your goals.'],
  };
  const [title, description] = notFound
    ? ['Shared page not found', 'This is not a supported share address. Check the full link with the person who sent it.']
    : intros[key] ?? ['Your next step starts here', 'Explore free fitness tools and practical training guides, or start planning your next workout.'];
  return (
    <div style={{ minHeight: '100dvh', background: 'var(--bg)', color: 'var(--text)' }}>
      <header style={{ padding: '20px 24px', borderBottom: '1px solid var(--border)', display: 'flex', gap: 24, flexWrap: 'wrap', alignItems: 'center' }}>
        <a href="/" style={{ color: 'inherit', fontWeight: 800, textDecoration: 'none' }} data-testid="link-loading-home">SnapMyGym</a>
        <nav aria-label="Explore SnapMyGym" style={{ display: 'flex', gap: 20 }}>
          <a href="/tools" data-testid="link-loading-tools">Free tools</a>
          <a href="/blog" data-testid="link-loading-blog">Guides</a>
          <a href="/pricing" data-testid="link-loading-pricing">Plans</a>
        </nav>
      </header>
      <main id="main-content" style={{ maxWidth: 760, margin: '48px auto', padding: 24 }}>
        <h1 style={{ fontSize: 26 }}>{title}</h1>
        <p>{description}</p>
        <p style={{ color: 'var(--text-dim)' }}><a href="/">Explore SnapMyGym</a> · <a href="/tools">Use free tools</a></p>
      </main>
    </div>
  );
}